export const merchantTypes = {
  MERACCTID: 'MERACCTID',
  GET_BRANCHES_DATA: 'GET_BRANCHES_DATA',
  GET_BRANCH_DATA: 'GET_BRANCH_DATA',
  GET_PERSONAL_INFO: 'GET_PERSONAL_INFO',
  GET_PROD_TYPE_LIST: 'GET_PROD_TYPE_LIST',
}